import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Dialog, { DialogTitle, DialogContent, DialogActions } from 'material-ui/Dialog'
import Button from 'material-ui/Button'

import { toggleContractDialog, buyTokens } from 'modules/contracts'
import jsonSelector from 'selectors/json'
import parametersSelector from 'selectors/parameters'

const ContractModal = ({ toggleContractDialog, buyTokens, open, config_parameters, contracts }) => (
  <Dialog open={open} onClose={() => toggleContractDialog()} id="contract-modal">
    <DialogTitle>Purchase of {config_parameters['coin.tiker']} Tokens</DialogTitle>
    <DialogContent>
      <p>
        You are going to purchase <span className="coin-amount">{contracts.coin_amount}</span>{' '}
        {config_parameters['coin.tiker']} <span className="token-pluralize">tokens</span> at the
        price of <span className="coin-rate">{contracts.coin_rate}</span>{' '}
        <span className="currency">{contracts.currency}</span> per {config_parameters['coin.tiker']}{' '}
        Token.
        <span className="contract-modal-bonus-block">
          You will also receive <span className="coins-bonus">{contracts.coin_amount_bonus}</span>{' '}
          additional tokens to your account as a bonus.
        </span>
        {config_parameters['system.buy_tokens_agreement_enabled'] > 0 && (
          <span>
            Before purchasing you have to accept{' '}
            <a href={contracts.purchase_agreement_uri} className="link-to-pdf" target="_blank">
              {config_parameters['coin.tiker']} Token Purchase Agreement
            </a>.
          </span>
        )}
      </p>
    </DialogContent>
    <DialogActions>
      <Button color="primary" className="accept" onClick={() => buyTokens()}>
        Agree
      </Button>{' '}
      <Button color="default" onClick={() => toggleContractDialog()}>
        Close
      </Button>
    </DialogActions>
  </Dialog>
)

const mapStateToProps = state => ({
  open: state.contracts.index.contract_dialog_opened,
  contracts: jsonSelector('contracts.index')(state),
  config_parameters: parametersSelector(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ toggleContractDialog, buyTokens }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ContractModal)



// WEBPACK FOOTER //
// ./src/containers/pages/dashboard/contract_modal.js